import type { SxProps, Theme } from '@mui/material/styles';

export const groupTotalPillSx: SxProps<Theme> = {
  cursor: 'default',
  flexShrink: 0,
  whiteSpace: 'nowrap',
  '&:hover': { backgroundColor: (theme) => theme.palette.grey[50] },
};

export const groupTotalLabelSx: SxProps<Theme> = {
  color: (theme) => theme.palette.grey[500],
  whiteSpace: 'nowrap',
};
